import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sp-layout-dashboard-simple',
  templateUrl: './sp-layout-dashboard-simple.component.html',
  styleUrls: ['./sp-layout-dashboard-simple.component.scss']
})
export class SpLayoutDashboardSimpleComponent {}
